<script>
import { required } from "vuelidate/lib/validators";

import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import SuperService from "@/helpers/APIService/super.service";
import Multiselect from "vue-multiselect";

export default {
  page: {
    title: "Device Model",
  },
  emits: ["submitted", "cancelSubmit"],
  props: {
    currentProps: Object,
  },
  data() {
    return {
      iotGateways: [],
      iotDeviceModels: [],
      device_form: {
        iot_gateway: null,
        iot_device_model: null,
        device_name: null,
        device_address: null,
        firmware_version: null,
        ip_address: null,
        mac_address: null,
        remark: null,
      },
      submitted: false,
      isBtnLoading: false,
      isError: false,
      errorMessage: null,
    };
  },
  components: {
    Multiselect,
  },
  validations: {
    device_form: {
      iot_device_model: {
        required,
      },
      device_name: {
        required,
      },
      device_address: {
        required,
      },
      firmware_version: {
        required,
      },
    },
  },
  mounted() {
    this.setValue();
    this.getGateways();
    this.getDeviceModels();
  },
  methods: {
    // Method is used to get list of gateways
    async getGateways() {
      try {
        const response = await SuperService.getGatewayList();
        if (response) {
          response.results.map((item) => {
            this.iotGateways.push({ text: item.name, value: item.id });
          });
        }
      } catch (error) {
        this.isLoading = false;
        errorHandler(error);
      }
    },
    // Method is used to get list of device models
    async getDeviceModels() {
      try {
        const response = await UserService.getDeviecModelList();
        if (response) {
          response.map((item) => {
            if (this.currentProps.isEdit) {
              if (item.name == this.currentProps.device.iot_device_model.name) {
                this.device_form.iot_device_model = item.id;
              }
            }
            this.iotDeviceModels.push({ text: item.name, value: item.id });
          });
        }
      } catch (error) {
        this.isLoading = false;
        errorHandler(error);
      }
    },
    // Method is used to handle set value
    setValue() {
      if (this.currentProps.isEdit) {
        this.device_form.iot_gateway = this.currentProps.device.iot_gateway.id;
        this.device_form.device_name = this.currentProps.device.device_name;
        this.device_form.device_address =
          this.currentProps.device.device_address;
        this.device_form.firmware_version =
          this.currentProps.device.firmware_version;
        this.device_form.ip_address = this.currentProps.device.ip_address;
        this.device_form.mac_address = this.currentProps.device.mac_address;
        this.device_form.remark = this.currentProps.device.remark;
      }
    },
    // Method is used to add and update device model data
    onSubmit() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        if (this.currentProps.isEdit == false) {
          UserService.addDeviece(this.device_form)
            .then((response) => {
              this.isBtnLoading = false;
              this.submitted = false;
              this.$emit("submitted", { data: response });
              this.isError = false;
            })
            .catch((error) => {
              this.isError = true;
              if (Array.isArray(error.response.data)) {
                error.response.data.map((item) => {
                  this.errorMessage.push(item);
                });
              } else {
                this.errorMessage = error.response.data;
              }
              this.isBtnLoading = false;
              errorHandler(error);
            });
        } else {
          UserService.editDevieceData(
            this.currentProps.deviceId,
            this.device_form
          )
            .then((response) => {
              this.$emit("submitted", { data: response, isEdit: true });
              this.isBtnLoading = false;
              this.submitted = false;
              this.isError = false;
            })
            .catch((error) => {
              this.isError = true;
              if (Array.isArray(error.response.data)) {
                error.response.data.map((item) => {
                  this.errorMessage.push(item);
                });
              } else {
                this.errorMessage = error.response.data;
              }
              this.isBtnLoading = false;
              errorHandler(error);
            });
        }
      }
    },
  },
};
</script>

<template>
  <div class="container-fluid">
    <div class="col-sm-12">
      <h4>{{ currentProps.isEdit ? "Update" : "Add New" }} Device</h4>
      <hr />
    </div>
    <b-form @submit.prevent="onSubmit">
      <div class="row">
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="iot_gateway">IOT Gateway </label>
            <multiselect
              v-model="device_form.iot_gateway"
              :options="iotGateways"
              :show-labels="false"
              placeholder=""
              label="text"
              track-by="value"
              id="iot_gateway"
            ></multiselect>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="iot_device_model"
              >IOT Device Model <span class="text-danger">*</span></label
            >
            <multiselect
              v-model="device_form.iot_device_model"
              :options="iotDeviceModels"
              :show-labels="false"
              placeholder=""
              label="text"
              track-by="value"
              id="iot_device_model"
              :class="{
                'is-invalid':
                  submitted && $v.device_form.iot_device_model.$error,
              }"
            ></multiselect>

            <div v-if="submitted" class="invalid-feedback">
              <span v-if="!$v.device_form.iot_device_model.required"
                >Device Model is required.</span
              >
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="device_name"
              >Name <span class="text-danger">*</span></label
            >
            <b-form-input
              id="device_name"
              type="text"
              v-model="device_form.device_name"
              autocomplete="off"
              :class="{
                'is-invalid': submitted && $v.device_form.device_name.$error,
              }"
            ></b-form-input>
            <div v-if="submitted" class="invalid-feedback">
              <span v-if="!$v.device_form.device_name.required"
                >Name is required.</span
              >
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="device_address"
              >Device Address <span class="text-danger">*</span></label
            >
            <b-form-input
              id="device_address"
              type="text"
              v-model="device_form.device_address"
              autocomplete="off"
              :class="{
                'is-invalid': submitted && $v.device_form.device_address.$error,
              }"
            ></b-form-input>
            <div v-if="submitted" class="invalid-feedback">
              <span v-if="!$v.device_form.device_address.required"
                >Device Address is required.</span
              >
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="firmware_version"
              >Firmware Version <span class="text-danger">*</span></label
            >
            <b-form-input
              id="firmware_version"
              type="text"
              v-model="device_form.firmware_version"
              autocomplete="off"
              :class="{
                'is-invalid':
                  submitted && $v.device_form.firmware_version.$error,
              }"
            ></b-form-input>
            <div v-if="submitted" class="invalid-feedback">
              <span v-if="!$v.device_form.firmware_version.required"
                >Firmware Version is required.</span
              >
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="mac_address">Mac Address </label>
            <b-form-input
              id="mac_address"
              type="text"
              v-model="device_form.mac_address"
              autocomplete="off"
            ></b-form-input>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="ip_address">IP Address </label>
            <b-form-input
              id="ip_address"
              type="text"
              v-model="device_form.ip_address"
              autocomplete="off"
            ></b-form-input>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="remark">Remark </label>
            <b-form-input
              id="remark"
              type="text"
              v-model="device_form.remark"
              autocomplete="off"
            ></b-form-input>
          </div>
        </div>
        <b-alert v-if="isError" show variant="danger">
          <ul>
            <li v-for="(error, index) in errorMessage" :key="index">
              {{ index }}: {{ error[0] }}
            </li>
          </ul>
        </b-alert>
        <hr />
        <div class="col-sm-12">
          <b-button
            class="float-end ms-2"
            variant="outline-primary"
            type="reset"
            @click="$emit('cancelSubmit')"
            >Cancel</b-button
          >

          <b-button
            class="float-end"
            variant="outline-primary"
            type="button"
            @click="onSubmit"
          >
            <i
              v-if="isBtnLoading"
              class="bx bx-loader bx-spin font-size-16 align-middle me-2"
            ></i>
            {{ currentProps.isEdit ? "Update" : "Save" }}
          </b-button>
        </div>
      </div>
    </b-form>
  </div>
</template>
